'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _navbar = require('./navbar/navbar.component');

var _navbar2 = _interopRequireDefault(_navbar);

var _leftnav = require('./leftnav/leftnav.component');

var _leftnav2 = _interopRequireDefault(_leftnav);

var _usersFilter = require('./users-filter/users-filter.component');

var _usersFilter2 = _interopRequireDefault(_usersFilter);

var _profilesFilter = require('./profiles-filter/profiles-filter.component');

var _profilesFilter2 = _interopRequireDefault(_profilesFilter);

var _userBasicDetails = require('./user-basic-details/user-basic-details.component');

var _userBasicDetails2 = _interopRequireDefault(_userBasicDetails);

var _userAddressDetails = require('./user-address-details/user-address-details.component');

var _userAddressDetails2 = _interopRequireDefault(_userAddressDetails);

var _userPaymentDetails = require('./user-payment-details/user-payment-details.component');

var _userPaymentDetails2 = _interopRequireDefault(_userPaymentDetails);

var _userClientDetails = require('./user-client-details/user-client-details.component');

var _userClientDetails2 = _interopRequireDefault(_userClientDetails);

var _userProviderDetails = require('./user-provider-details/user-provider-details.component');

var _userProviderDetails2 = _interopRequireDefault(_userProviderDetails);

var _userProfileCompleteness = require('./user-profile-completeness/user-profile-completeness.component');

var _userProfileCompleteness2 = _interopRequireDefault(_userProfileCompleteness);

var _userRatings = require('./user-ratings/user-ratings.component');

var _userRatings2 = _interopRequireDefault(_userRatings);

var _userTimesheets = require('./user-timesheets/user-timesheets.component');

var _userTimesheets2 = _interopRequireDefault(_userTimesheets);

var _userWalletTransactions = require('./user-wallet-transactions/user-wallet-transactions.component');

var _userWalletTransactions2 = _interopRequireDefault(_userWalletTransactions);

var _userChildren = require('./user-children/user-children.component');

var _userChildren2 = _interopRequireDefault(_userChildren);

var _userVouches = require('./user-vouches/user-vouches.component');

var _userVouches2 = _interopRequireDefault(_userVouches);

var _userExternalAccounts = require('./user-external-accounts/user-external-accounts.component');

var _userExternalAccounts2 = _interopRequireDefault(_userExternalAccounts);

var _userGuardians = require('./user-guardians/user-guardians.component');

var _userGuardians2 = _interopRequireDefault(_userGuardians);

var _userJobPreferences = require('./user-job-preferences/user-job-preferences.component');

var _userJobPreferences2 = _interopRequireDefault(_userJobPreferences);

var _userCertificates = require('./user-certificates/user-certificates.component');

var _userCertificates2 = _interopRequireDefault(_userCertificates);

var _mediaFilter = require('./media-filter/media-filter.component');

var _mediaFilter2 = _interopRequireDefault(_mediaFilter);

var _surveyFilter = require('./survey-filter/survey-filter.component');

var _surveyFilter2 = _interopRequireDefault(_surveyFilter);

var _certificatesFilter = require('./certificates-filter/certificates-filter.component');

var _certificatesFilter2 = _interopRequireDefault(_certificatesFilter);

var _checksFilter = require('./checks-filter/checks-filter.component');

var _checksFilter2 = _interopRequireDefault(_checksFilter);

var _jobsFilter = require('./jobs-filter/jobs-filter.component');

var _jobsFilter2 = _interopRequireDefault(_jobsFilter);

var _jobRequestsFilter = require('./job-requests-filter/job-requests-filter.component');

var _jobRequestsFilter2 = _interopRequireDefault(_jobRequestsFilter);

var _affiliatesFilter = require('./affiliates-filter/affiliates-filter.component');

var _affiliatesFilter2 = _interopRequireDefault(_affiliatesFilter);

var _vouchesFilter = require('./vouches-filter/vouches-filter.component');

var _vouchesFilter2 = _interopRequireDefault(_vouchesFilter);

var _userMessages = require('./user-messages/user-messages.component');

var _userMessages2 = _interopRequireDefault(_userMessages);

var _botManagerFilter = require('./bot-manager-filter/bot-manager-filter.component');

var _botManagerFilter2 = _interopRequireDefault(_botManagerFilter);

var _userPayAgreements = require('./user-pay-agreements/user-pay-agreements.component');

var _userPayAgreements2 = _interopRequireDefault(_userPayAgreements);

var _botSessionsFilter = require('./bot-sessions-filter/bot-sessions-filter.component');

var _botSessionsFilter2 = _interopRequireDefault(_botSessionsFilter);

var _businessesFilter = require('./businesses-filter/businesses-filter.component');

var _businessesFilter2 = _interopRequireDefault(_businessesFilter);

var _postJob = require('./post-job/post-job.component');

var _postJob2 = _interopRequireDefault(_postJob);

var _userInvoices = require('./user-invoices/user-invoices.component');

var _userInvoices2 = _interopRequireDefault(_userInvoices);

var _userJobEdit = require('./user-job-edit/user-job-edit.component');

var _userJobEdit2 = _interopRequireDefault(_userJobEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonComponents = _angular2.default.module('app.common.components', []).component('navbar', _navbar2.default).component('leftnav', _leftnav2.default).component('usersFilter', _usersFilter2.default).component('profilesFilter', _profilesFilter2.default).component('userBasicDetails', _userBasicDetails2.default).component('userAddressDetails', _userAddressDetails2.default).component('userPaymentDetails', _userPaymentDetails2.default).component('userClientDetails', _userClientDetails2.default).component('userProviderDetails', _userProviderDetails2.default).component('userProfileCompleteness', _userProfileCompleteness2.default).component('userRatings', _userRatings2.default).component('userTimesheets', _userTimesheets2.default).component('userWalletTransactions', _userWalletTransactions2.default).component('userChildren', _userChildren2.default).component('userVouches', _userVouches2.default).component('userExternalAccounts', _userExternalAccounts2.default).component('userGuardians', _userGuardians2.default).component('userJobPreferences', _userJobPreferences2.default).component('userCertificates', _userCertificates2.default).component('mediaFilter', _mediaFilter2.default).component('surveyFilter', _surveyFilter2.default).component('certificatesFilter', _certificatesFilter2.default).component('checksFilter', _checksFilter2.default).component('jobsFilter', _jobsFilter2.default).component('jobRequestsFilter', _jobRequestsFilter2.default).component('affiliatesFilter', _affiliatesFilter2.default).component('vouchesFilter', _vouchesFilter2.default).component('userMessages', _userMessages2.default).component('botManagerFilter', _botManagerFilter2.default).component('botSessionsFilter', _botSessionsFilter2.default).component('businessesFilter', _businessesFilter2.default).component('postJob', _postJob2.default).component('userInvoices', _userInvoices2.default).component('userPayAgreements', _userPayAgreements2.default).component('userJobEdit', _userJobEdit2.default);

exports.default = CommonComponents;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/index.js
 **/